import { createContext, Dispatch } from "react";
import { RegisterTestActions } from "./testRegistryActions";
import { IRegistryReportsTest } from "../../types";

export const initialStateTestRegistry: IRegistryReportsTest = {
  addQuestion: false,
  editTest: false,
  openForm: false,
  test: {
    ID: 0,
    Title: "",
    QuestionsID: [],
    Collections: {
      Title: "",
      ID: 0
    }
  },
  minCorrectAnswersCount: 0
};

export const TestRegistryContext = createContext<{
  state: IRegistryReportsTest;
  dispatchTestRegistry: Dispatch<RegisterTestActions>;
}>({
  state: initialStateTestRegistry,
  dispatchTestRegistry: () => undefined
});
